import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
// import "../../_css/Faqs.css"
import { Link } from 'react-router-dom';


const tutorialData = [
    {
        thumbnail: 'https://via.placeholder.com/300x200?text=Tutorial+1',
        filterType: 'Video',
        tags: ['Video', '2 min'],
        title: 'Getting Started with WorkEwhere',
        description: 'A brief guide to navigating the platform and accessing key features for a smooth start.',
        cta: 'Watch Now'
    },
    {
        thumbnail: 'https://via.placeholder.com/300x200?text=Tutorial+2',
        filterType: 'Video',
        tags: ['Empathy', 'Persuasion', 'Decision'],
        title: 'Mastering Role Play Simulations',
        description: 'How to choose roles, select competencies, and engage with AI-driven role plays.',
        cta: 'Watch Now'
    },
    {
        thumbnail: 'https://via.placeholder.com/300x200?text=Tutorial+3',
        filterType: 'Video',
        tags: ['Video', '3 min'],
        title: 'Understanding AI Feedback',
        description: 'Watch how WorkEwhere provides real-time feedback to enhance your skills.',
        cta: 'Watch Now'
    },
    {
        thumbnail: 'https://via.placeholder.com/300x200?text=Tutorial+4',
        filterType: 'Step',
        tags: ['6 Steps'],
        title: 'Creating Custom Role Play Scenarios',
        description: 'Easily write or upload documents to create personalized role play simulations.',
        cta: 'Read More'
    },
    {
        thumbnail: 'https://via.placeholder.com/300x200?text=Tutorial+5',
        filterType: 'Step',
        tags: ['3 Steps'],
        title: 'Interpreting Performance Analytics',
        description: 'Improve your skills through various metrics on your dashboard.',
        cta: 'Read More'
    },
    {
        thumbnail: 'https://via.placeholder.com/300x200?text=Tutorial+6',
        filterType: 'Other',
        tags: ['Account', 'Competencies', 'Privacy'],
        title: 'Manage Account and Privacy Settings',
        description: 'Quick guide to updating your settings and securely requesting data deletion.',
        cta: 'Read More',
        ctaLink: '/tutorials/manageAccountSetting'
    },
];
const Tutorials = ({ searchTerm = '' }) => {
    const [filterType, setFilterType] = useState('All');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Debug logging
    console.log('filterType:', filterType, 'dropdownOpen:', dropdownOpen);

    const handleDropdownToggle = () => {
        console.log('Dropdown clicked, current state:', dropdownOpen);
        setDropdownOpen(!dropdownOpen);
    };

    const handleOptionClick = (value) => {
        console.log('Option clicked:', value);
        setFilterType(value);
        setDropdownOpen(false);
    };

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);



    const filteredTutorials = tutorialData.filter(tutorial =>
        (filterType === 'All' || tutorial.tags.includes(filterType)) &&
        tutorial.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div style={{ padding: '20px', fontFamily: 'Plus Jakarta Sans, sans-serif', }}>
            <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: '24px'
            }}>
                <span style={{
                    font: "Clash Display",
                    fontWeight: "600",
                    lineHeight: "32px",
                    fontSize: "24px",
                    verticalAlign: "middle",
                    color: "#374151",
                    letterSpacing: "0%"
                }}>Tutorials</span>

                {/* Debug info */}
                {/* <div style={{ fontSize: '12px', color: '#666', marginRight: '16px' }}>
                    Debug: {dropdownOpen ? 'OPEN' : 'CLOSED'}
                </div> */}

                <div style={{ position: 'relative' }}>
                    <div ref={dropdownRef} style={{ position: 'relative', display: 'inline-block', zIndex: 999 }}>
                        <button
                            onClick={handleDropdownToggle}
                            style={{
                                backgroundColor: '#F9FAFB',
                                color: '#374151',
                                fontFamily: 'Plus Jakarta Sans, sans-serif',
                                fontWeight: '500',
                                fontSize: '14px',
                                padding: '8px 16px',
                                border: '1px solid #E5E7EB',
                                borderRadius: '9999px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)'
                            }}
                        >
                            {filterType}
                            {dropdownOpen ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                        </button>

                        {dropdownOpen && (
                            <div style={{
                                position: 'absolute',
                                top: 'calc(100% + 8px)',
                                right: 0,
                                backgroundColor: '#ffffff',
                                borderRadius: '12px',
                                boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.08)',
                                padding: '10px 0',
                                width: '140px',
                                zIndex: 1000,
                                border: '1px solid #E5E7EB'
                            }}>
                                {['All', 'Video', 'Step'].map((type) => (
                                    <div
                                        key={type}
                                        onClick={() => handleOptionClick(type)}
                                        style={{
                                            padding: '10px 16px',
                                            fontSize: '14px',
                                            fontFamily: 'Plus Jakarta Sans, sans-serif',
                                            color: '#374151',
                                            cursor: 'pointer',
                                            transition: 'background-color 0.2s',
                                            whiteSpace: 'nowrap',
                                            backgroundColor: type === filterType ? '#F3F4F6' : 'transparent'
                                        }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#F3F4F6'}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = type === filterType ? '#F3F4F6' : 'transparent'}
                                    >
                                        {type}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                gap: '24px'
            }}>
                {filteredTutorials.map((tutorial, index) => (
                    <div key={index} style={{
                        background: '#fff',
                        borderRadius: '16px',
                        padding: '16px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        border: '1px solid #FFFFFF'
                    }}>
                        <div style={{
                            width: '100%',
                            height: '140px',
                            borderRadius: '12px',
                            background: "#F3F4F6",
                            gap: "10px"
                        }}>
                            <img
                                src={tutorial.thumbnail}
                                alt={tutorial.title}
                                style={{
                                    width: '100%',
                                    height: '140px',
                                    borderRadius: '12px',
                                    background: "#F3F4F6",
                                    objectFit: 'cover'
                                }}
                            />
                        </div>
                        <span style={{
                            fontFamily: "Plus Jakarta Sans",
                            fontSize: '16px',
                            fontWeight: '700',
                            color: '#000000',
                            margin: 0,
                            letterSpacing: "0%",
                            verticalAlign: "middle",
                            lineHeight: "24px"

                        }}>
                            {tutorial.title}
                        </span>
                        <p style={{
                            fontFamily: "Plus Jakarta Sans",
                            fontSize: '14px',
                            color: '#4B5563',
                            margin: 0,
                            fontWeight: "400",
                            verticalAlign: "middle",
                            lineHeight: '20px'
                        }}>
                            {tutorial.description}
                        </p>
                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '8px'
                        }}>
                            {tutorial.tags.map((tag, idx) => (
                                <span key={idx} style={{
                                    backgroundColor: '#F3F4F6',
                                    color: '#4B5563',
                                    fontSize: '12px',
                                    padding: '4px 8px',
                                    borderRadius: '20px'
                                }}>
                                    {tag}
                                </span>
                            ))}
                        </div>
                        <Link
                            to={tutorial.ctaLink}
                            style={{
                                marginTop: 'auto',
                                background: '#23B4C3',
                                color: '#FFFFFF',
                                border: 'none',
                                borderRadius: '27px',
                                padding: '8px 12px',
                                fontWeight: '500',
                                fontFamily: 'Plus Jakarta Sans',
                                fontSize: '14px',
                                textAlign: 'center',
                                textDecoration: 'none',
                                display: 'inline-block'
                            }}
                        >
                            {tutorial.cta}
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Tutorials;